module.exports = __webpack_public_path__ + "static/media/cargando.99c4b543.flr";